import useGetUserNewsTipTableColumns from './useGetUserNewsTipTableColumns'

export default useGetUserNewsTipTableColumns
